import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-invitation-request-modal',
  templateUrl: './invitation-request-modal.component.html',
  styleUrls: ['./invitation-request-modal.component.css'],
})
export class InvitationRequestModalComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
